import React, { useEffect, useState } from "react";
import AdminLTE, {
  Inputs,
} from "adminlte-2-react";
import GoogleMapReact from "google-map-react";
import { Modal, Button } from "react-bootstrap";
import Geocode from "react-geocode";

import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const marker = require("./img/marker.png").default;
const { Text } = Inputs;

const Marker = ({}) => (
  <img
    alt="Marker"
    src={marker}
    style={{
      position: "absolute",
      top: "48%",
      left: "48%",
      width: 20,
      height: 20,
    }}
  />
);

function Direccion({ direccion, setDireccion, initialRegion, setLat, setLng }) {
  Geocode.setApiKey("AIzaSyBlOqbGYSHLWIwZnYaG42BzQpY76COLxHg");
  
  const [center, setCenter] = useState(
    initialRegion
      ? initialRegion
      : {
          lat: -25.2819,
          lng:  -57.635,
        }
  );

  useEffect(() => {
    if(initialRegion && initialRegion.lat && initialRegion.lng){
      setCenter(initialRegion);
    }

  }, [initialRegion]);
 
  const [show, setShow] = useState(false);

  let zoom = 11;
    
  const setDirFromLatLng = () => {
    Geocode.fromLatLng(center.lat, center.lng).then(
      (response) => {
        const address = response.results[0].formatted_address;
        let city, state, country;
        for (
          let i = 0;
          i < response.results[0].address_components.length;
          i++
        ) {
          for (
            let j = 0;
            j < response.results[0].address_components[i].types.length;
            j++
          ) {
            switch (response.results[0].address_components[i].types[j]) {
              case "locality":
                city = response.results[0].address_components[i].long_name;
                break;
              case "administrative_area_level_1":
                state = response.results[0].address_components[i].long_name;
                break;
              case "country":
                country = response.results[0].address_components[i].long_name;
                break;
            }
          }
        }

      },
      (error) => {
        console.error(error);
      }
    );
  };

  return (
    <div>
      <Text
        labelPosition="above"
        size="sm"
        label={<Etiqueta texto="Dirección del local (tipear dirección)" obligatorio={true} />}
        value={direccion}
        onChange={(evt) => setDireccion(evt.target.value)}
      />

      <Button bsStyle="primary" onClick={() => setShow(true)}>
        Geolocalizar
      </Button>

      <Modal
        show={show}
        style={{opacity:1}}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header style={{marginTop:200}} closeButton={false}>
          <Modal.Title>Seleccionar ubicación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{height: "40vh", width: '100%' }}>

            <GoogleMapReact
              onChange={(region) => {
                setLat(region.center.lat)
                setLng(region.center.lng)
                setCenter(region.center);
              }}
              bootstrapURLKeys={{
                key: "AIzaSyBlOqbGYSHLWIwZnYaG42BzQpY76COLxHg",
              }}
              defaultCenter={center}
              defaultZoom={zoom}
            ></GoogleMapReact>
          </div>
          <Marker />
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="primary"
            onClick={() => {
              // setDirFromLatLng();
              setShow(false);
            }}
          >
            Seleccionar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Direccion;
